// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"31d6cfe0","580":"31d6cfe0","603":"31d6cfe0","685":"31d6cfe0","728":"31d6cfe0"}[chunkId] + ".chunk.css";
};